<div *ngIf="showContent" class="container">
  <h2 class="title">Product Services</h2>
  <h3 class="subtitle">Maak een keuze uit de volgende acties</h3>

  <div class="product-service-items">
    <ul *ngFor="let item of data.product.services;">
      <li alt="{{item.productServiceDescription}}"
          (click)="navigateTo(item.productServiceUrl)"
          matTooltip="{{item.productServiceDescription}}">
        {{item.productServiceName}} <span> > </span>
      </li>
    </ul>
  </div>
</div>
